<tni-contact-center-agent-control [agentEmployeeId]="agentIdObs | async"></tni-contact-center-agent-control>
